import React from 'react';
import { Helmet } from 'react-helmet-async';
import BoomBoxClassicArticle from '../components/BoomBoxClassicArticle';

/**
 * BoomBox Classic Article Page
 * JSU vs Southern - September 26, 2026
 */
const BoomBoxClassicPage = () => {
  return (
    <>
      <Helmet>
        <title>Jackson State Dominates Southern in BoomBox Classic | SheLovesThee</title>
        <meta name="description" content="Jackson State rolled to a 35-17 victory over Southern in front of 38,973 fans at Veterans Memorial Stadium. Full game recap and player spotlights." />
        <meta property="og:title" content="Jackson State Dominates Southern in BoomBox Classic" />
        <meta property="og:description" content="The Tigers rolled to a 35-17 victory in the 2026 BoomBox Classic. 38,973 fans witnessed the rivalry showdown." />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <BoomBoxClassicArticle />
    </>
  );
};

export default BoomBoxClassicPage;
